import {
  SHIFT_DATE_RANGE,
  SHIFT_TYPE,
  SHIFT_DOCTORS,
  SELECT_TYPE,
  ACTIVE_TYPE,
  SHIFT_CATEGORIES,
  SHIFT_PAYMENT_TYPE,
  SHIFT_TOGGLE_IN_ON_TIME,
  SHIFT_TOGGLE_OUT_ON_TIME,
  SHIFT_GP,
  SHIFT_NON_GP_TIME_RANGE,
  SHIFT_NON_GP,
  DELETE_SHIFT_NON_GP_DAY_TIME_RANGE,
  STATUS_DOCTOR_SHIFT_CREATE,
  FETCH_ACTIVE_DOCTOR_SHIFTS_SUCCESS,
  SHIFT_GET_DATA_SUCCESS,
  SHIFT_SEARCH_TYPE,
  SHIFT_SEARCH_TYPE_DOCTOR,
  SHIFT_SEARCH_TYPE_DATE_RANGE,
  SHIFT_SEARCH_SUBMIT_STATUS,
  SHIFT_SEARCH_TYPE_SHIFT_CATEGORY,
  SHIFT_EDIT,
  SHIFT_EDIT_SUCCESS,
  SHIFT_SET_IS_CHECKED,
  SHIFT_CHANGE_DIALOG_BOX,
  SHIFT_SET_DELETE_ID,
  SHIFT_EDIT_DOCTOR_ID,
  SHIFT_EDIT_START_DATE,
  SHIFT_EDIT_END_DATE,
  SHIFT_EDIT_PAYMENT_TYPE,
  SHIFT_EDIT_REMARK,
  SHIFT_EDIT_AUTO_TOGGLE_IN_ON_THAT_TIME,
  SHIFT_EDIT_AUTO_TOGGLE_OUT_ON_THAT_TIME,
  SHIFT_EDIT_CATEGORY_ID,
  SHIFT_EDIT_STATUS,
  CLEAR_NEW_DOCTOR_SHIFT,
} from "../constants/doctorShift.constants";
import {
  FETCH_SHIFT_CATEGORIES_SUCCESS,
  SHIFT_CATEGORY_NAME,
  SHIFT_CATEGORY_ORDER,
  SHIFT_CATEGORY_SHIFT_TYPE,
  SHIFT_CATEGORY_DESCRIPTION,
  SHIFT_CATEGORY_ACTION_SUCCESS,
  SHIFT_CATEGORY_EDIT,
  SHIFT_CATEGORY_DIALOG_BOX_STATUS,
  SHIFT_CATEGORY_SET_DELETE_ID,
  GET_SHIFTS_SUCCESS,
} from "../constants/shiftCategories.constants";
import { FETCH_ALL_DOCTOR_SUCCESS } from "../constants/doctors.constants";
import moment from "moment";

const INIT_STATE = {
  doctorShifts: [],
  doctorActiveShifts: [],
  doctorShiftsData: {
    doctorShifts: [],
    dialogBoxStatus: false,
    delete_id: null,
    edit_shift_view: {
      id: null,
      doctor_id: "",
      start_time_date: "",
      end_time_date: "",
      payment_type: "",
      remark: "",
      auto_toggle_in_on_that_time: "",
      auto_toggle_out_on_that_time: "",
      shift_category_id: "",
    },
    edit_action_status: {
      open: false,
      status: "",
      message: "",
    },
    pagination: {
      current_page: 1,
      page_size: 0,
      total: 0,
      next_page: false,
      total_pages: 0,
    },
    search_type: "",
    search_by_doctor: [],
    search_by_shift_category: [],
    search_by_date_range: [null, null],
    search_submit_status: false,
  },
  newDoctorShift: {
    shift_date_range: [null, null],
    shift_doctors: [],
    shift_type: "",
    select_type: "",
    active_type: "",
    shift_categories: [],
    shift_payment_type: "",
    auto_toggle_in_on_that_time: false,
    auto_toggle_out_on_that_time: false,
    shift_gp: {},
    shift_non_gp_time_range: {
      Monday: { start_time: null, end_time: null },
      Tuesday: { start_time: null, end_time: null },
      Wednesday: { start_time: null, end_time: null },
      Thursday: { start_time: null, end_time: null },
      Friday: { start_time: null, end_time: null },
      Saturday: { start_time: null, end_time: null },
      Sunday: { start_time: null, end_time: null },
    },
    shift_non_gp: {},
  },
  dataForForm: {
    doctors: [],
    shift_categories: [],
    shift_categories_filter: [],
  },
  shiftCategories: {
    shift_categories: [],
    new_shift_category: {
      id: null,
      name: "",
      order: 0,
      shift_type: "",
      description: "",
    },
    dialogBoxStatus: false,
    delete_id: null,
    pagination: {
      current_page: 1,
      page_size: 0,
      total: 0,
      next_page: false,
      total_pages: 0,
    },
  },
  shifts: [],
};

const doctorShiftInfo = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SHIFT_DATE_RANGE: {
      return {
        ...state,
        newDoctorShift: {
          ...state.newDoctorShift,
          shift_date_range: action.shift_date_range,
        },
      };
    }
    case SHIFT_TYPE: {
      let new_shift_categories_filter = state.dataForForm.shift_categories_filter;
      if (action.shift_type === "gp") {
        new_shift_categories_filter = state.dataForForm.shift_categories.filter(
          (shift_category) => shift_category.shift_type_id === 0
        );
      }
      if (action.shift_type === "non_gp") {
        new_shift_categories_filter = state.dataForForm.shift_categories.filter(
          (shift_category) => shift_category.shift_type_id === 1
        );
      }
      return {
        ...state,
        newDoctorShift: {
          ...state.newDoctorShift,
          shift_type: action.shift_type,
        },
        dataForForm: {
          ...state.dataForForm,
          shift_categories_filter: new_shift_categories_filter,
        },
      };
    }
    case SELECT_TYPE: {
      return {
        ...state,
        newDoctorShift: {
          ...state.newDoctorShift,
          select_type: action.select_type,
        },
      };
    }
    case ACTIVE_TYPE: {
      return {
        ...state,
        newDoctorShift: {
          ...state.newDoctorShift,
          active_type: action.active_type,
        },
      };
    }
    case SHIFT_DOCTORS: {
      return {
        ...state,
        newDoctorShift: {
          ...state.newDoctorShift,
          shift_doctors: action.shift_doctors,
        },
      };
    }
    case SHIFT_CATEGORIES: {
      return {
        ...state,
        newDoctorShift: {
          ...state.newDoctorShift,
          shift_categories: action.shift_categories,
        },
      };
    }
    case SHIFT_PAYMENT_TYPE: {
      return {
        ...state,
        newDoctorShift: {
          ...state.newDoctorShift,
          shift_payment_type: action.shift_payment_type,
        },
      };
    }
    case SHIFT_TOGGLE_IN_ON_TIME: {
      return {
        ...state,
        newDoctorShift: {
          ...state.newDoctorShift,
          auto_toggle_in_on_that_time: !action.auto_toggle_in_on_that_time,
        },
      };
    }
    case SHIFT_TOGGLE_OUT_ON_TIME: {
      return {
        ...state,
        newDoctorShift: {
          ...state.newDoctorShift,
          auto_toggle_out_on_that_time: !action.auto_toggle_out_on_that_time,
        },
      };
    }
    case SHIFT_GP: {
      return {
        ...state,
        newDoctorShift: {
          ...state.newDoctorShift,
          shift_gp: action.shift_gp,
        },
      };
    }
    case SHIFT_NON_GP_TIME_RANGE: {
      return {
        ...state,
        newDoctorShift: {
          ...state.newDoctorShift,
          shift_non_gp_time_range: action.shift_non_gp_time_range,
        },
      };
    }
    case SHIFT_NON_GP: {
      return {
        ...state,
        newDoctorShift: {
          ...state.newDoctorShift,
          shift_non_gp: action.shift_non_gp,
        },
      };
    }
    case DELETE_SHIFT_NON_GP_DAY_TIME_RANGE: {
      return {
        ...state,
        newDoctorShift: {
          ...state.newDoctorShift,
          shift_non_gp: action.updated_shift_non_gp,
        },
      };
    }
    case STATUS_DOCTOR_SHIFT_CREATE: {
      if (action.shift_create_status) {
        return {
          ...state,
          newDoctorShift: INIT_STATE.newDoctorShift,
        };
      }
      break;
    }
    case FETCH_SHIFT_CATEGORIES_SUCCESS: {
      const { current_page, page_size, total, next_page } = action.shift_categories.paginate;
      let new_shift_categories_filter = action.shift_categories.data;
      if (state.newDoctorShift.shift_type === "gp") {
        new_shift_categories_filter = state.dataForForm.shift_categories.filter(
          (shift_category) => shift_category.shift_type_id === 0
        );
      }
      if (state.newDoctorShift.shift_type === "non_gp") {
        new_shift_categories_filter = state.dataForForm.shift_categories.filter(
          (shift_category) => shift_category.shift_type_id === 1
        );
      }
      return {
        ...state,
        dataForForm: {
          ...state.dataForForm,
          shift_categories: action.shift_categories.data,
          shift_categories_filter: new_shift_categories_filter,
        },
        shiftCategories: {
          ...state.shiftCategories,
          shift_categories: action.shift_categories.data,
          pagination: {
            ...state.shiftCategories.pagination,
            current_page: current_page !== undefined ? parseInt(current_page) : 1,
            page_size: parseInt(page_size),
            total: parseInt(total),
            next_page: next_page,
            total_pages: Math.round(parseInt(total) / parseInt(page_size)),
          },
        },
      };
    }
    case FETCH_ALL_DOCTOR_SUCCESS: {
      return {
        ...state,
        dataForForm: {
          ...state.dataForForm,
          doctors: modifyDoctorsData(action.payload.data),
        },
      };
    }
    // shift categories
    case SHIFT_CATEGORY_NAME: {
      return {
        ...state,
        shiftCategories: {
          ...state.shiftCategories,
          new_shift_category: {
            ...state.shiftCategories.new_shift_category,
            name: action.shift_category_name,
          },
        },
      };
    }
    case SHIFT_CATEGORY_ORDER: {
      return {
        ...state,
        shiftCategories: {
          ...state.shiftCategories,
          new_shift_category: {
            ...state.shiftCategories.new_shift_category,
            order: action.shift_category_order,
          },
        },
      };
    }
    case SHIFT_CATEGORY_SHIFT_TYPE: {
      return {
        ...state,
        shiftCategories: {
          ...state.shiftCategories,
          new_shift_category: {
            ...state.shiftCategories.new_shift_category,
            shift_type: action.shift_category_shift_type,
          },
        },
      };
    }
    case SHIFT_CATEGORY_DESCRIPTION: {
      return {
        ...state,
        shiftCategories: {
          ...state.shiftCategories,
          new_shift_category: {
            ...state.shiftCategories.new_shift_category,
            description: action.shift_category_description,
          },
        },
      };
    }
    case SHIFT_CATEGORY_ACTION_SUCCESS: {
      const { current_page, page_size, total, next_page } = action.shift_categories.paginate;
      return {
        ...state,
        shiftCategories: {
          ...state.shiftCategories,
          shift_categories: action.shift_categories.data,
          new_shift_category: INIT_STATE.shiftCategories.new_shift_category,
          delete_id: null,
          pagination: {
            ...state.shiftCategories.pagination,
            current_page: current_page !== undefined ? parseInt(current_page) : 1,
            page_size: parseInt(page_size),
            total: parseInt(total),
            next_page: next_page,
            total_pages: Math.round(parseInt(total) / parseInt(page_size)),
          },
        },
      };
    }
    case SHIFT_CATEGORY_EDIT: {
      const id = action.shift_category_id;
      const filterData = state.shiftCategories.shift_categories.filter(
        (shift_category) => shift_category.id === parseInt(id)
      )[0];
      const { name, order, shift_type_id, description } = filterData;
      const newShiftCategoriesData = {
        id: id,
        name: name,
        order: order,
        shift_type: shift_type_id === 0 ? "gp" : "non_gp",
        description: description === null ? "" : description,
      };
      return {
        ...state,
        shiftCategories: {
          ...state.shiftCategories,
          new_shift_category: newShiftCategoriesData,
        },
      };
    }
    // start edit onchange
    case SHIFT_EDIT: {
      let edit_shift_data = {};
      const shift_view_id = action.shift_id;
      Object.keys(state.doctorShiftsData.doctorShifts).forEach(function (key) {
        let doctorShiftArray = [...state.doctorShiftsData.doctorShifts[key]];
        doctorShiftArray.forEach((doctorShift) => {
          if (doctorShift.id === parseInt(shift_view_id)) {
            edit_shift_data = doctorShift;
          }
        });
      });
      const {
        id,
        doctor_id,
        start_time_date,
        end_time_date,
        auto_toggle_in_on_time,
        auto_toggle_out_on_time,
        remark,
        payment_type,
        shift_category_id,
      } = edit_shift_data;
      moment.defaultFormat = "YYYY-MM-DDTHH:mm:ss";
      const newShiftViewData = {
        id: id,
        doctor_id: doctor_id,
        start_time_date: moment(start_time_date, moment.defaultFormat).toDate(),
        end_time_date: moment(end_time_date, moment.defaultFormat).toDate(),
        auto_toggle_in_on_that_time: auto_toggle_in_on_time,
        auto_toggle_out_on_that_time: auto_toggle_out_on_time,
        remark: remark,
        payment_type: payment_type,
        shift_category_id: shift_category_id,
      };
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          edit_shift_view: newShiftViewData,
        },
      };
    }
    case SHIFT_EDIT_DOCTOR_ID: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          edit_shift_view: {
            ...state.doctorShiftsData.edit_shift_view,
            doctor_id: action.doctor_id,
          },
        },
      };
    }
    case SHIFT_EDIT_START_DATE: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          edit_shift_view: {
            ...state.doctorShiftsData.edit_shift_view,
            start_time_date: action.start_date,
          },
        },
      };
    }
    case SHIFT_EDIT_END_DATE: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          edit_shift_view: {
            ...state.doctorShiftsData.edit_shift_view,
            end_time_date: action.end_date,
          },
        },
      };
    }
    case SHIFT_EDIT_PAYMENT_TYPE: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          edit_shift_view: {
            ...state.doctorShiftsData.edit_shift_view,
            payment_type: action.payment_type,
          },
        },
      };
    }
    case SHIFT_EDIT_REMARK: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          edit_shift_view: {
            ...state.doctorShiftsData.edit_shift_view,
            remark: action.remark,
          },
        },
      };
    }
    case SHIFT_EDIT_AUTO_TOGGLE_IN_ON_THAT_TIME: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          edit_shift_view: {
            ...state.doctorShiftsData.edit_shift_view,
            auto_toggle_in_on_that_time: action.auto_toggle_in_on_that_time,
          },
        },
      };
    }
    case SHIFT_EDIT_AUTO_TOGGLE_OUT_ON_THAT_TIME: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          edit_shift_view: {
            ...state.doctorShiftsData.edit_shift_view,
            auto_toggle_out_on_that_time: action.auto_toggle_out_on_that_time,
          },
        },
      };
    }
    case SHIFT_EDIT_CATEGORY_ID: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          edit_shift_view: {
            ...state.doctorShiftsData.edit_shift_view,
            shift_category_id: action.shift_category_id,
          },
        },
      };
    }
    case SHIFT_EDIT_SUCCESS: {
      const {
        id,
        doctor_id,
        start_time_date,
        end_time_date,
        payment_type,
        remark,
        auto_toggle_in_on_time,
        auto_toggle_out_on_time,
        shift_category_id,
      } = action.shift_data;
      moment.defaultFormat = "YYYY-MM-DDTHH:mm:ss";
      let update_shift_data = {
        id: id,
        doctor_id: doctor_id,
        start_time_date: moment(start_time_date, moment.defaultFormat).toDate(),
        end_time_date: moment(end_time_date, moment.defaultFormat).toDate(),
        payment_type: payment_type,
        remark: remark,
        auto_toggle_in_on_that_time: auto_toggle_in_on_time,
        auto_toggle_out_on_that_time: auto_toggle_out_on_time,
        shift_category_id: shift_category_id,
      };
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          edit_shift_view: update_shift_data,
        },
      };
    }
    case SHIFT_EDIT_STATUS: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          edit_action_status: action.status,
        },
      };
    }
    case SHIFT_CATEGORY_DIALOG_BOX_STATUS: {
      return {
        ...state,
        shiftCategories: {
          ...state.shiftCategories,
          dialogBoxStatus: action.status,
        },
      };
    }
    case SHIFT_CATEGORY_SET_DELETE_ID: {
      return {
        ...state,
        shiftCategories: {
          ...state.shiftCategories,
          delete_id: action.delete_id,
        },
      };
    }
    case FETCH_ACTIVE_DOCTOR_SHIFTS_SUCCESS: {
      return {
        ...state,
        doctorActiveShifts: action.doctor_active_shifts,
      };
    }
    // SHIFT GET PROCESS
    case SHIFT_GET_DATA_SUCCESS: {
      const { current_page, page_size, total, next_page } = action.shift_data.paginate;
      const doctorShiftData = action.shift_data.data;
      Object.keys(doctorShiftData).map(function (key) {
        let doctorShiftArray = [...doctorShiftData[key]];
        const newDoctorShiftArray = doctorShiftArray.map((doctorShift) => ({
          ...doctorShift,
          isChecked: false,
        }));
        doctorShiftData[key] = newDoctorShiftArray;
      });
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          doctorShifts: doctorShiftData,
          delete_id: null,
          pagination: {
            ...state.shiftCategories.pagination,
            current_page: current_page !== undefined ? parseInt(current_page) : 1,
            page_size: parseInt(page_size),
            total: parseInt(total),
            next_page: next_page,
            total_pages: Math.round(parseInt(total) / parseInt(page_size)),
          },
        },
      };
    }
    case SHIFT_SEARCH_TYPE: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          search_type: action.search_type,
        },
      };
    }
    case SHIFT_SEARCH_TYPE_DOCTOR: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          search_by_doctor: action.search_doctor,
        },
      };
    }
    case SHIFT_SEARCH_TYPE_SHIFT_CATEGORY: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          search_by_shift_category: action.search_shift_category,
        },
      };
    }
    case SHIFT_SEARCH_TYPE_DATE_RANGE: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          search_by_date_range: action.search_date_range,
        },
      };
    }
    case SHIFT_SEARCH_SUBMIT_STATUS: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          search_submit_status: action.search_submit_status,
        },
      };
    }
    case SHIFT_SET_IS_CHECKED: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          doctorShifts: action.shift_data,
        },
      };
    }
    case SHIFT_CHANGE_DIALOG_BOX: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          dialogBoxStatus: action.dialog_box_status,
        },
      };
    }
    case SHIFT_SET_DELETE_ID: {
      return {
        ...state,
        doctorShiftsData: {
          ...state.doctorShiftsData,
          delete_id: action.delete_id,
        },
      };
    }
    case CLEAR_NEW_DOCTOR_SHIFT: {
      return {
        ...state,
        newDoctorShift: INIT_STATE.newDoctorShift,
      };
    }
    case GET_SHIFTS_SUCCESS: {
      return {
        ...state,
        shifts: action.shift_data.data
      }
    }
    default:
      return state;
  }
};

export default doctorShiftInfo;

const modifyDoctorsData = (doctors) => {
  return doctors.map(
    ({
      created_at,
      updated_at,
      order,
      email,
      gender,
      dob,
      address,
      phone,
      norm_phone,
      registration_body,
      reg_no,
      nic,
      norm_nic,
      practice_location,
      pre_booking_text,
      consultation_duration,
      is_on_demand,
      photo_signature,
      photo_nic,
      photo_medical_licence,
      photo_profile,
      is_insurance_policy,
      fee,
      medical_school,
      qualification,
      bank_acc_name,
      bank_accont_no,
      bank_name,
      branch,
      package_id,
      medical_licence_exp,
      comment,
      status,
      country,
      specialty,
      languages,
      photo_seal,
      average_wait_time,
      ...rest
    }) => ({ ...rest })
  );
};
